<app-header [title]="'Audit'" [notificationsCount]="commentsNotification.unreadCount()" [showSearchIcon]="false" [showFilterIcon]="false" [showDesktopFilters]="false" [filterDefinitions]="[]" (refresh)="onAuditSearch()"></app-header>
<div class="audit-page" [style.paddingTop.px]="(ui.searchOpen() || ui.filtersOpen()) ? 0 : 70">

  <!-- Audit Filter Bar -->
  <div class="audit-filter-bar" [class.collapsed]="filtersCollapsed">
    <button type="button" class="audit-filter-header" (click)="toggleFilters()" (keydown.enter)="toggleFilters()" (keydown.space)="toggleFilters(); $event.preventDefault()" aria-label="Toggle search filters">
      <span class="audit-filter-title">Search Filters</span>
      <img class="audit-filter-chevron" [class.rotated]="filtersCollapsed" src="/assets/images/Expand_Chevron.png" alt="Toggle">
    </button>

    <div class="audit-filter-fields" *ngIf="!filtersCollapsed">
      <!-- All 6 filter fields in a single grid; CSS controls 2-col (mobile) vs 3-col (desktop) -->
      <div class="filter-grid">
        <div class="filter-field">
          <label class="filter-label" for="scheduledDate">Scheduled Delivery Date</label>
          <input id="scheduledDate" type="date" class="filter-input" [(ngModel)]="filterScheduledDate">
        </div>
        <div class="filter-field">
          <label class="filter-label" for="loadNumber">Load Number</label>
          <input id="loadNumber" type="text" class="filter-input" placeholder="e.g. 12345" [(ngModel)]="filterLoadNumber">
        </div>
        <div class="filter-field">
          <label class="filter-label" for="cropYear">Crop Year</label>
          <input id="cropYear" type="number" class="filter-input" placeholder="e.g. 2024" [(ngModel)]="filterCropYear">
        </div>
        <div class="filter-field">
          <label class="filter-label" for="vendorNumber">Vendor Number</label>
          <input id="vendorNumber" type="text" class="filter-input" placeholder="e.g. V001" [(ngModel)]="filterVendorNumber">
        </div>
        <div class="filter-field">
          <label class="filter-label" for="destination">Destination</label>
          <input id="destination" type="text" class="filter-input" placeholder="e.g. Plant A" [(ngModel)]="filterDestination">
        </div>
        <div class="filter-field">
          <label class="filter-label" for="variety">Variety</label>
          <input id="variety" type="text" class="filter-input" placeholder="e.g. Ranger" [(ngModel)]="filterVariety">
        </div>
      </div>

      <!-- Actions row -->
      <div class="filter-actions-row">
        <button class="audit-search-btn" [disabled]="!hasFilterValues || isLoading()" (click)="onAuditSearch()">
          <span *ngIf="!isLoading()">Search</span>
          <span *ngIf="isLoading()">Searching...</span>
        </button>
        <button class="audit-clear-btn" (click)="onClearFilters()">Clear</button>
      </div>
    </div>
  </div>

  <div *ngIf="auditSearchError() as err" class="audit-search-error" role="alert">
    {{ err }}
  </div>

  <!-- Mobile View -->
  <div class="mobile-view">
    <app-no-passports *ngIf="hasSearched && visibleRecords.length === 0"></app-no-passports>
    <div class="audit-prompt" *ngIf="!hasSearched && visibleRecords.length === 0">
      <p class="prompt-text">Use the filters above to search for passports.</p>
    </div>

    <ng-container *ngFor="let rec of visibleRecords; trackBy: trackById; let i = index">
      <div class="audit-mobile-passport-row" [attr.data-passport-id]="rec.id">
        <app-audit-passport-cell [recordId]="rec.id"
        [loadNumber]="detailsStore.get(rec.id)?.loadNumber || rec.id"
        [scheduledText]="((detailsStore.get(rec.id)?.dueDateTime) | dateWithOrdinal:'EEE, d MMM y, HH:mm') || 'No scheduled date'"
        [vendorName]="detailsStore.get(rec.id)?.vendorName || ''"
        [variety]="detailsStore.get(rec.id)?.variety || ''"
        [bulkerNumber]="detailsStore.get(rec.id)?.bulkerMain || detailsStore.get(rec.id)?.bulkerNumber || ''"
        [haulier]="detailsStore.get(rec.id)?.haulier || ''"
        [origin]="detailsStore.get(rec.id)?.origin || ''"
        [destination]="detailsStore.get(rec.id)?.destinationWeighbridge || detailsStore.get(rec.id)?.destination || ''"
        [apn]="detailsStore.get(rec.id)?.apn || ''"
        [apnName]="detailsStore.get(rec.id)?.apnName || ''"
        [vendorNumber]="detailsStore.get(rec.id)?.vendorNumber || ''"
        [status]="rec.status"
        [styleState]="getStyleState(rec.id)"
        [class.expanded]="ui.expandedRecordId() === rec.id"></app-audit-passport-cell>
      <div class="passport-cell-spacer"></div>
      </div>
    </ng-container>
  </div>

  <!-- Desktop View -->
  <app-passports-desktop-table
    [sortedPaginatedRecords]="sortedPaginatedRecords"
    [visibleRecordsLength]="totalRecords"
    [customEmptyText]="hasSearched ? '' : 'Use the filters above to search for passports.'"
    [hideStatusTabs]="true"
    [selectedTab]="'all'"
    [allCount]="allCount"
    [loadCount]="loadCount"
    [shuntingCount]="shuntingCount"
    [transloadingCount]="transloadingCount"
    [receivingCount]="receivingCount"
    [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage"
    [totalPages]="totalPages"
    [rowsDropdownOpen]="rowsDropdownOpen"
    [detailsStore]="detailsStore"
    (sort)="onSort($event)"
    (pageChange)="onPageChange($event)"
    (toggleRowsDropdown)="toggleRowsDropdown($event)"
    (setItemsPerPage)="setItemsPerPage($event)"
    (refresh)="onAuditSearch()"
    (openPassportDetails)="openPassportDetails($event)"
    (openHistory)="openHistory($event)"
    (openComments)="openComments($event)">
  </app-passports-desktop-table>
</div>

<app-loading-spinner [isLoading]="isLoading()" text="Searching passports..."></app-loading-spinner>

<app-navbar [items]="[
  { id: 'profile', label: 'Profile', selectedIcon: '/assets/images/Person_Selected.png', unselectedIcon: '/assets/images/Person_Unselected.png' },
  { id: 'home', label: 'Homepage', selectedIcon: '/assets/images/Home_Selected.png', unselectedIcon: '/assets/images/Home_Unselected.png' },
  { id: 'contacts', label: 'Contacts', selectedIcon: '/assets/images/Contact_Selected.png', unselectedIcon: '/assets/images/Contact_Unselected.png' }
]" [selectedId]="'home'" (selectedIdChange)="onNavChange($event)"></app-navbar>
